angular.module('env.userSettings', [])

    .provider('userSettings', function ($localStorageProvider) {

        var _this = this;
        var userSettingsKey = "om.userSettings";

        /**
         * User settings object
         */
        _this.settings = reloadSettings();

        /**
         * Save current settings to local storage
         */
        function saveSettings() {
            _this.settings = _this.settings || {};
            $localStorageProvider.setItem(userSettingsKey, _this.settings);
            return _this.settings;
        }

        /**
         * Reload settings from local storage
         */
        function reloadSettings() {
            _this.settings = $localStorageProvider.getItem(userSettingsKey);
            if (!_this.settings || _.isEqual(_this.settings, {})) {
                _this.settings = _.clone(om.config.defaultUserSettings);
            }
            return _this.settings;
        }

        _.extend(_this, {
            save: saveSettings,
            reload: reloadSettings
        });

        this.$get = function () {
            return _this;
        }
    });